<template>
  <IconSvgBase :class="$style.icon" :view-width="16" :view-height="16">
    <path
      d="M8.00065 6.99976C7.44932 6.99976 7.00065 7.44843 7.00065 7.99976C7.00065 8.5511 7.44932 8.99976 8.00065 8.99976C8.55198 8.99976 9.00065 8.5511 9.00065 7.99976C9.00065 7.44843 8.55198 6.99976 8.00065 6.99976ZM8.00065 10.3331C6.71398 10.3331 5.66732 9.28643 5.66732 7.99976C5.66732 6.7131 6.71398 5.66643 8.00065 5.66643C9.28732 5.66643 10.334 6.7131 10.334 7.99976C10.334 9.28643 9.28732 10.3331 8.00065 10.3331ZM14.5793 7.66776C14.1533 6.92643 11.8047 3.21043 7.81998 3.3351C4.13532 3.4291 1.99132 6.67576 1.42198 7.66776C1.30465 7.87376 1.30465 8.12576 1.42198 8.33176C1.84198 9.0631 4.10865 12.6664 8.01732 12.6664C8.07132 12.6664 8.12598 12.6658 8.18132 12.6644C11.866 12.5704 14.01 9.32376 14.5793 8.33176C14.6967 8.12576 14.6967 7.87376 14.5793 7.66776Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconEye',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;
  fill: currentcolor;
}
</style>
